module.exports = __webpack_public_path__ + "static/media/stoicism-ai.cb30881d.png";